namespace GeniuzPOS.Lookups {
    export interface VpoSparamRow {
        Id?: number;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TelId?: string;
        FaxId?: string;
        Email?: string;
        RegId?: string;
        TaxId?: string;
        BizType?: string;
        VatFg?: number;
        TaxInvName?: string;
        TaxInvAddrLine1?: string;
        TaxInvAddrLine2?: string;
        TaxInvAddrLine3?: string;
        PosId?: string;
        PosPermitNo?: string;
        ShopId?: string;
        WhsId?: string;
        LastReceiptRunNo?: number;
        LastRefundRunNo?: number;
        CashierPosFg?: number;
        PosScreenType?: string;
        PosTouchPanelId?: string;
        MaxCashInDrawer?: number;
        AutoChargeFg?: number;
        AutoChargeRate?: number;
        MandatorySalesmanFg?: number;
        MandatoryMemberFg?: number;
        ConnectPrinterFg?: number;
        ConnectDrawerFg?: number;
        ConnectVfdFg?: number;
        Connect2ndDispFg?: number;
        ConnectEdcFg?: number;
        ConnectRfidReaderFg?: number;
        SellingPriceNo?: number;
        PsParaDefault1?: number;
        ShopLogoOnFrontScreen?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
        RecptNoBarcodeFg?: number;
        PsParaDefault2?: number;
        SelectSellingPriceFg?: number;
        ReceiptPrinterType?: number;
        SalesDocFg?: number;
        SalesVatType?: string;
        EjournalFg?: number;
        NoOfRecptCopy?: number;
        PrintOrderFg?: number;
        PrintQueueFg?: number;
        ItemOnRecptMethod?: number;
        RecptSumItemQtyFg?: number;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        BranchName?: string;
        ShopAddress?: string;
        ShopRegName?: string;
        ShopRegAddressLine1?: string;
        ShopRegAddressLine2?: string;
        ShopRegAddressLine3?: string;
        ShopRegId?: string;
        ShopTaxId?: string;
        ChargeVatRate?: number;
        PosProcessMode?: string;
        WeightBarcodePrefix?: string;
        PointRedeemOneBaht?: number;
        DiscRoundMethod?: number;
        CashPayRoundMethod?: number;
        MbDiscMethod?: number;
        AllowSaleOverStock?: number;
        PromptPayLink?: string;
        QrCodeAccount?: string;
    }

    export namespace VpoSparamRow {
        export const idProperty = 'PosId';
        export const nameProperty = 'BizName';
        export const localTextPrefix = 'Lookups.VpoSparam';
        export const lookupKey = 'VpoSparamRow';

        export function getLookup(): Q.Lookup<VpoSparamRow> {
            return Q.getLookup<VpoSparamRow>('VpoSparamRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            BizName = "BizName",
            BizAddressLine1 = "BizAddressLine1",
            BizAddressLine2 = "BizAddressLine2",
            BizAddressLine3 = "BizAddressLine3",
            TelId = "TelId",
            FaxId = "FaxId",
            Email = "Email",
            RegId = "RegId",
            TaxId = "TaxId",
            BizType = "BizType",
            VatFg = "VatFg",
            TaxInvName = "TaxInvName",
            TaxInvAddrLine1 = "TaxInvAddrLine1",
            TaxInvAddrLine2 = "TaxInvAddrLine2",
            TaxInvAddrLine3 = "TaxInvAddrLine3",
            PosId = "PosId",
            PosPermitNo = "PosPermitNo",
            ShopId = "ShopId",
            WhsId = "WhsId",
            LastReceiptRunNo = "LastReceiptRunNo",
            LastRefundRunNo = "LastRefundRunNo",
            CashierPosFg = "CashierPosFg",
            PosScreenType = "PosScreenType",
            PosTouchPanelId = "PosTouchPanelId",
            MaxCashInDrawer = "MaxCashInDrawer",
            AutoChargeFg = "AutoChargeFg",
            AutoChargeRate = "AutoChargeRate",
            MandatorySalesmanFg = "MandatorySalesmanFg",
            MandatoryMemberFg = "MandatoryMemberFg",
            ConnectPrinterFg = "ConnectPrinterFg",
            ConnectDrawerFg = "ConnectDrawerFg",
            ConnectVfdFg = "ConnectVfdFg",
            Connect2ndDispFg = "Connect2ndDispFg",
            ConnectEdcFg = "ConnectEdcFg",
            ConnectRfidReaderFg = "ConnectRfidReaderFg",
            SellingPriceNo = "SellingPriceNo",
            PsParaDefault1 = "PsParaDefault1",
            ShopLogoOnFrontScreen = "ShopLogoOnFrontScreen",
            ShopLogoOnReceipt = "ShopLogoOnReceipt",
            RecptHeadMesg1 = "RecptHeadMesg1",
            RecptHeadMesg2 = "RecptHeadMesg2",
            RecptHeadMesg3 = "RecptHeadMesg3",
            RecptHeadMesg4 = "RecptHeadMesg4",
            RecptHeadMesg5 = "RecptHeadMesg5",
            RecptHeadMesg6 = "RecptHeadMesg6",
            RecptFootMesg1 = "RecptFootMesg1",
            RecptFootMesg2 = "RecptFootMesg2",
            RecptFootMesg3 = "RecptFootMesg3",
            RecptFootMesg4 = "RecptFootMesg4",
            RecptFootMesg5 = "RecptFootMesg5",
            RecptFootMesg6 = "RecptFootMesg6",
            RecptFootMesg7 = "RecptFootMesg7",
            RecptFootMesg8 = "RecptFootMesg8",
            RecptFootMesg9 = "RecptFootMesg9",
            RecptFootMesg10 = "RecptFootMesg10",
            RecptNoBarcodeFg = "RecptNoBarcodeFg",
            PsParaDefault2 = "PsParaDefault2",
            SelectSellingPriceFg = "SelectSellingPriceFg",
            ReceiptPrinterType = "ReceiptPrinterType",
            SalesDocFg = "SalesDocFg",
            SalesVatType = "SalesVatType",
            EjournalFg = "EjournalFg",
            NoOfRecptCopy = "NoOfRecptCopy",
            PrintOrderFg = "PrintOrderFg",
            PrintQueueFg = "PrintQueueFg",
            ItemOnRecptMethod = "ItemOnRecptMethod",
            RecptSumItemQtyFg = "RecptSumItemQtyFg",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            BranchName = "BranchName",
            ShopAddress = "ShopAddress",
            ShopRegName = "ShopRegName",
            ShopRegAddressLine1 = "ShopRegAddressLine1",
            ShopRegAddressLine2 = "ShopRegAddressLine2",
            ShopRegAddressLine3 = "ShopRegAddressLine3",
            ShopRegId = "ShopRegId",
            ShopTaxId = "ShopTaxId",
            ChargeVatRate = "ChargeVatRate",
            PosProcessMode = "PosProcessMode",
            WeightBarcodePrefix = "WeightBarcodePrefix",
            PointRedeemOneBaht = "PointRedeemOneBaht",
            DiscRoundMethod = "DiscRoundMethod",
            CashPayRoundMethod = "CashPayRoundMethod",
            MbDiscMethod = "MbDiscMethod",
            AllowSaleOverStock = "AllowSaleOverStock",
            PromptPayLink = "PromptPayLink",
            QrCodeAccount = "QrCodeAccount"
        }
    }
}
